(() => {
  const filters = document.querySelector('[data-new-arrivals-filter]');
  if (!filters || filters.dataset.initialized) return;
  const section = filters.closest('[data-section-id]');
  const grid = section && section.querySelector('#Collection');
  if (!grid) return;
  filters.dataset.initialized = 'true';

  const basePath = new URL(filters.dataset.collectionUrl, location.origin).pathname;
  const presalePath = filters.dataset.presaleUrl;
  const drawer = document.querySelector('.collection-filters-mobile');
  const status = section.querySelector('[data-arrivals-status]');
  const message = status.querySelector('[data-arrivals-message]');
  const retry = status.querySelector('[data-arrivals-retry]');
  const spanish = document.documentElement.lang.startsWith('es');
  const copy = {
    loading: spanish ? 'Cargando productos…' : 'Loading products…',
    error: spanish ? 'No pudimos cargar los productos. Inténtalo de nuevo.' : 'We could not load the products. Please try again.',
    empty: spanish ? 'No se encontraron productos.' : 'No products found.'
  };
  let controller;
  let state = readState();
  let draft = state;

  function readState() {
    const url = new URL(location.href);
    let tags = decodeURIComponent(url.pathname.slice(basePath.length)).replace(/^\/+|\/+$/g, '').split('+').filter(Boolean);
    const fall26 = url.searchParams.get('season') === 'FALL26' || tags.includes('season-ss22') || tags.includes('pre-sale');
    if (fall26 && url.searchParams.has('tags')) tags = url.searchParams.get('tags').split(',').filter(Boolean);
    return {
      season: fall26 ? 'fall26' : tags.includes('season-all-time') ? 'all-time' : '',
      tags: tags.filter(tag => !['season-ss22', 'season-all-time', 'pre-sale'].includes(tag)),
      page: url.searchParams.get('page') || '1'
    };
  }

  function urlFor(next) {
    const url = new URL(location.href);
    ['season', 'tags', 'page', 'section_id', 'sections'].forEach(key => url.searchParams.delete(key));
    url.pathname = basePath;
    if (next.season === 'fall26') {
      url.searchParams.set('season', 'FALL26');
      if (next.tags.length) url.searchParams.set('tags', next.tags.join(','));
    } else {
      const tags = next.season === 'all-time' ? [...next.tags, 'season-all-time'] : next.tags;
      if (tags.length) url.pathname += '/' + tags.map(encodeURIComponent).join('+');
    }
    if (next.page !== '1') url.searchParams.set('page', next.page);
    return url;
  }

  function toggle(next, item) {
    const result = { ...next, tags: [...next.tags], page: '1' };
    if (item.dataset.season) {
      result.season = result.season === item.dataset.season ? '' : item.dataset.season;
    } else {
      const tag = item.dataset.handleTag;
      result.tags = result.tags.includes(tag) ? result.tags.filter(value => value !== tag) : [...result.tags, tag];
    }
    return result;
  }

  function paint(scope, next) {
    scope.querySelectorAll('.topbar-filter__values [data-season], .topbar-filter__values [data-handle-tag]').forEach(item => {
      const active = item.dataset.season ? next.season === item.dataset.season : next.tags.includes(item.dataset.handleTag);
      item.classList.toggle('tag-filter--active', active);
      if (item.dataset.keyRel === 'color') item.classList.toggle('filter-tag-color--active', active);
      if (item.dataset.keyRel === 'size') item.classList.toggle('filter-tag-size--active', active);
      const link = item.querySelector('a');
      link.href = urlFor(toggle(next, item)).href;
      link.setAttribute('aria-current', String(active));
    });
    if (scope !== filters) return;

    const current = filters.querySelector('.topbar-filter__current');
    const list = current.querySelector('ul');
    const clear = list.querySelector('.tag-filter--static');
    list.replaceChildren();
    filters.querySelectorAll('.topbar-filter__values .tag-filter--active').forEach(item => {
      const chip = document.createElement('li');
      chip.className = 'topbar-filter__tag tag-filter--active';
      if (item.dataset.season) chip.dataset.season = item.dataset.season;
      else chip.dataset.handleTag = item.dataset.handleTag;
      const link = document.createElement('a');
      link.href = urlFor(toggle(next, item)).href;
      link.textContent = item.querySelector('a').textContent.trim() + ' ×';
      chip.append(link);
      list.append(chip);
    });
    list.append(clear);
    clear.querySelector('a').href = urlFor({ season: '', tags: [], page: '1' }).href;
    const active = Boolean(next.season || next.tags.length);
    current.classList.toggle('topbar-filter---open-current', active);
    const trigger = filters.querySelector('.topbar-filter-current, .topbar-filter-current--disabled');
    trigger.className = active ? 'topbar-filter-current' : 'topbar-filter-current--disabled';
  }

  function paginationLinks() {
    grid.querySelectorAll('.pagination a').forEach(link => {
      const page = new URL(link.href).searchParams.get('page') || '1';
      link.dataset.arrivalsPage = page;
      link.href = urlFor({ ...state, page }).href;
    });
  }

  async function load(next, push = true) {
    if (controller) controller.abort();
    const request = new AbortController();
    controller = request;
    state = next;
    if (push) history.pushState(null, '', urlFor(next));
    paint(filters, next);
    grid.hidden = true;
    grid.setAttribute('aria-busy', 'true');
    status.hidden = false;
    message.textContent = copy.loading;
    retry.hidden = true;
    const timeout = setTimeout(() => request.abort(), 20000);

    try {
      if (next.season === 'fall26' && !presalePath) throw new Error('Pre-sale collection unavailable');
      const url = urlFor(next);
      const tags = next.season === 'all-time' ? [...next.tags, 'season-all-time'] : next.tags;
      url.pathname = (next.season === 'fall26' ? presalePath : basePath) + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
      url.searchParams.delete('season');
      url.searchParams.delete('tags');
      // Render the existing grid in the source collection's context, with native pagination and prices.
      url.searchParams.set('section_id', section.dataset.sectionId);
      const response = await fetch(url.href, { signal: request.signal });
      if (!response.ok) throw new Error('Collection request failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = html.querySelector('#Collection');
      if (!result) throw new Error('Collection grid missing');
      if (request !== controller || request.signal.aborted) return;
      grid.replaceChildren(...result.childNodes);
      if (!grid.querySelector('a[href*="/products/"]') && !grid.textContent.trim()) {
        const empty = document.createElement('p');
        empty.className = 'text-center';
        empty.textContent = copy.empty;
        grid.append(empty);
      }
      const counts = html.querySelectorAll('.filters-toolbar__product-count');
      section.querySelectorAll('.filters-toolbar__product-count').forEach((count, index) => {
        if (counts[index]) count.textContent = counts[index].textContent;
      });
      paginationLinks();
      grid.hidden = false;
      status.hidden = true;
    } catch (error) {
      if (request !== controller) return;
      message.textContent = copy.error;
      retry.hidden = false;
    } finally {
      clearTimeout(timeout);
      if (request === controller) grid.removeAttribute('aria-busy');
    }
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('collection-filters-mobile--active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  // Capture these clicks before the legacy mobile handler builds a collection/tag URL.
  document.addEventListener('click', event => {
    const target = event.target.closest('a, button, #topbar-show-filters, .topbar-filter-current');
    if (!target) return;
    if (target.id === 'topbar-show-filters') {
      draft = { ...state, tags: [...state.tags] };
      return;
    }
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const inDrawer = drawer && drawer.contains(target);
    const item = target.closest('[data-season], [data-handle-tag]');
    const isFilter = item && (filters.contains(item) || inDrawer);
    const isClear = (filters.contains(target) && target.closest('.tag-filter--static')) || (inDrawer && target.matches('.collection-filters-mobile__clear'));
    const isApply = inDrawer && target.matches('.collection-filters-mobile__apply');
    const isPage = grid.contains(target) && target.hasAttribute('data-arrivals-page');
    const isRetry = target === retry;
    const isCurrent = filters.contains(target) && target.matches('.topbar-filter-current');
    if (!isFilter && !isClear && !isApply && !isPage && !isRetry && !isCurrent) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (isCurrent) {
      filters.querySelector('.topbar-filter__values').classList.remove('topbar-filter---open-values');
      filters.querySelector('.topbar-filter__current').classList.add('topbar-filter---open-current');
    } else if (isFilter && inDrawer) {
      draft = toggle(draft, item);
      paint(drawer, draft);
    } else if (isFilter) {
      load(toggle(state, item));
    } else if (isClear || isApply) {
      closeDrawer();
      load(isClear ? { season: '', tags: [], page: '1' } : draft);
    } else if (isPage) {
      load({ ...state, page: target.dataset.arrivalsPage });
    } else if (isRetry) {
      load(state, false);
    }
  }, true);

  window.addEventListener('popstate', () => {
    closeDrawer();
    load(readState(), false);
  });
  paint(filters, state);
  paginationLinks();
  if (state.season === 'fall26') load(state, false);
})();
